<script setup>
// Read-only label/value pairs (a record's details in a view dialog or
// card). Two columns that collapse on narrow screens; span: 2 = full row.
//   <UiDetailList :items="[{ label: 'Purpose', value: row.purpose, span: 2 }]" />
defineProps({
  items: { type: Array, required: true }, // [{ label, value, span? }]
  columns: { type: Number, default: 2 },
});
</script>

<template>
  <dl class="ui-details" :style="{ '--cols': columns }">
    <div
      v-for="item in items"
      :key="item.label"
      class="ui-details__item"
      :class="{ 'ui-details__item--wide': item.span === 2 }"
    >
      <dt>{{ item.label }}</dt>
      <dd>
        <slot :name="item.label" :item="item">
          {{ item.value === null || item.value === undefined || item.value === '' ? '—' : item.value }}
        </slot>
      </dd>
    </div>
  </dl>
</template>

<style scoped>
.ui-details {
  display: grid;
  grid-template-columns: repeat(var(--cols), minmax(0, 1fr));
  gap: 16px;
  margin: 0;
}
.ui-details__item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}
.ui-details__item--wide {
  grid-column: 1 / -1;
}
dt {
  font-size: 13px;
  color: var(--muted-foreground);
}
dd {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  overflow-wrap: anywhere;
  white-space: pre-line;
}
@media (max-width: 600px) {
  .ui-details {
    grid-template-columns: 1fr;
  }
}
</style>
